import { Box } from '@material-ui/core'
import { AuthContext } from 'context'
import {
  DOCUMENT_PATH,
  NO_USE_PATH,
  REJECTED_PATH,
  REPORT_PATH,
  RETENTION_PATH,
  SEND_PATH,
  SUPREPORT_PATH,
  TAX_ANALYSIS_PATH,
  UPLOAD_PATH,
} from 'lib'
import {
  SendDocumentReports,
  SendRejectedReports,
  SendRetentionReports,
  SendSupplierReport,
  TaxAnalysisReports,
  UploadExcelPage,
} from 'pages'
import NoUseReports from 'pages/SendRetentionReports/NoUseReports'
import React from 'react'
import { Route } from 'react-router-dom'

const Reports = () => {
  const { user } = React.useContext(AuthContext)
  return (
    <React.Fragment>
      {Boolean(user) && (
        <React.Fragment>
          <Route
            strict
            path={`${REPORT_PATH}${SEND_PATH}${DOCUMENT_PATH}`}
            component={SendDocumentReports}
          />
          <Route
            strict
            path={`${REPORT_PATH}${SEND_PATH}${REJECTED_PATH}`}
            component={SendRejectedReports}
          />
          <Route
            strict
            path={`${REPORT_PATH}${SEND_PATH}${RETENTION_PATH}`}
            component={SendRetentionReports}
          />
          <Route
            strict
            path={`${REPORT_PATH}${SEND_PATH}${SUPREPORT_PATH}`}
            component={SendSupplierReport}
          />
          <Route
            strict
            path={`${REPORT_PATH}${SEND_PATH}${TAX_ANALYSIS_PATH}`}
            component={TaxAnalysisReports}
          />
          <Route
            strict
            path={`${REPORT_PATH}${SEND_PATH}${NO_USE_PATH}`}
            component={NoUseReports}
          />
          <Route
            strict
            path={`${REPORT_PATH}${UPLOAD_PATH}${DOCUMENT_PATH}`}
            component={UploadExcelPage}
          />
        </React.Fragment>
      )}
    </React.Fragment>
  )
}

export default Reports
